import React, {useEffect, useRef} from 'react';
import {MODAL_FADE_CLASSES, MODAL_FADE_STYLES} from "../../Modals/ModalFadeScreen";

import EmbiggenerContents from "./EmbiggenerContents";
import clsx from 'clsx';
import {enableScrolling} from "../../Utility/html";

export default function Embiggener({
  selectedImage, callbacks, images = [], productGroup, ...props
}) {
  const ref = useRef();

  useEffect(() => {
    if (ref?.current) {
      // let e = globalThis.document?.documentElement;
      // e.requestFullscreen && e.requestFullscreen();
      // when first displaying, disable body scroll
      enableScrolling(false);
    }

    // CLEANUP - enable scrolling again (handleClose also does this)
    return () => {
      enableScrolling(true);
    }
  }, [ref]);

  const handleClose = e => {
    enableScrolling(true);
    callbacks.setEmbiggened(false);
    e.stopPropagation();
    // let doc = globalThis.document;
    // doc?.exitFullscreen && doc.exitFullscreen();
  }

  return <div ref={ref}
    className={clsx(MODAL_FADE_CLASSES)} style={MODAL_FADE_STYLES}>
    <div className="inset-2 md:inset-4 fixed">
      <EmbiggenerContents
        callbacks={callbacks}
        handleClose={handleClose}
        images={images}
        selectedImage={selectedImage}
        productGroup={productGroup}
        {...props} />
    </div>
  </div>
}
